import Itinerary from './itinerary.model';

export default class Trip {
    date: string;
    fromAirport: string;
    fromCity: string;
    fromCityObject: Itinerary | null;
    fromCode: string;
    id: number;
    lat: number;
    lng: number;
    toAirport: string;
    toCity: string;
    toCityObject: Itinerary | null;
    toCode: string;
    toLat: number;
    toLng: number;
    forceUpdate: boolean;
    toCityList: Array<Itinerary>;
    fromCityList: Array<Itinerary>;
    fromListEmpty: boolean;
    toListEmpty: boolean;
    isMissing: boolean;

    constructor() {
        this.date = '';
        this.fromAirport = '';
        this.fromCity = '';
        this.fromCityObject = null;
        this.fromCode = '';
        this.id = 0;
        this.lat = 0;
        this.lng = 0;
        this.toAirport = '';
        this.toCity = '';
        this.toCityObject = null;
        this.toCode = '';
        this.toLat = 0;
        this.toLng = 0;
        this.forceUpdate = false;
        this.toCityList = [];
        this.fromCityList = [];
        this.toListEmpty = false;
        this.fromListEmpty = false;
        this.isMissing = false;
    }
}